import { Component, Inject, ViewEncapsulation } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { CommonService } from "@services/common.service";

@Component({
    selector: "app-confirmation",
    templateUrl: "./confirmation.component.html",
    styleUrls: ["./confirmation.component.scss"],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class ConfirmationDialogComponent {
  message: string = "Are you sure?";
  actionButton: string = "delete";
  messageDetail: string = "";
  details: any = [];
  constructor(
    public commonService: CommonService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<ConfirmationDialogComponent>
  ) {
    if (data) {
      this.message = data.message || this.message;
      this.messageDetail = data.messageDetail || this.messageDetail;
      this.details = data.details || this.details;
      this.actionButton = data.actionButton || this.actionButton;
      if (data.actionButton) {
        this.actionButton = data.actionButton;
      }
    }
  }
  onNoClick(): void {
    this.dialogRef.close();
  }
  onConfirmClick(): void {
    this.dialogRef.close(true);
    //this.commonService.openRoadmapLinkDialog(event);
  }
}
